import script from "./DoubleListView.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleListView.vue?vue&type=script&setup=true&lang=js"

import "./DoubleListView.vue?vue&type=style&index=0&id=4eb60a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb60a64"]])

export default __exports__